export default __webpack_public_path__ + "static/media/header1.bf3dc89e.jpg";